import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import './ChatList.css';

const ChatList = () => {
  const navigate = useNavigate();
  const [sessionList, setSessionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    checkLoginStatus();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      loadSessionList();
    }
  }, [isLoggedIn]);

  const checkLoginStatus = () => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
    if (!token) {
      navigate('/login');
    } else {
      loadSessionList();
    }
  };

  const loadSessionList = async () => {
    try {
      setLoading(true);
      const result = await homeApi.getSessionList();
      console.log('会话列表数据:', result);
      if (result.code === 200) {
        const sessions = result.data || [];
        console.log('第一个会话的完整数据:', sessions[0]);
        console.log('第一个会话的所有字段:', sessions[0] ? Object.keys(sessions[0]) : []);
        setSessionList(sessions);
      }
    } catch (error) {
      console.error('获取会话列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const openChat = (session) => {
    navigate(`/chat?member_id=${session.other_member_id}&member_name=${encodeURIComponent(session.other_member_name)}&session_id=${session.id}`);
  };

  const formatTime = (formattedTime) => {
    console.log('formatTime 输入:', formattedTime);
    
    if (!formattedTime) return '';
    
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const currentDate = now.getDate();
    
    const parts = formattedTime.split('-');
    if (parts.length !== 2) return formattedTime;
    
    const month = parseInt(parts[0]);
    const day = parseInt(parts[1]);
    
    const today = new Date(currentYear, currentMonth - 1, currentDate);
    const yesterday = new Date(today.getTime() - 86400000);
    const messageDate = new Date(currentYear, month - 1, day);
    
    const weekAgo = new Date(today.getTime() - 7 * 86400000);
    
    const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    
    if (messageDate.getTime() === today.getTime()) {
      return `${hours}:${minutes}`;
    } else if (messageDate.getTime() === yesterday.getTime()) {
      return `昨天 ${hours}:${minutes}`;
    } else if (messageDate.getTime() > weekAgo.getTime()) {
      return `${weekDays[messageDate.getDay()]} ${hours}:${minutes}`;
    } else {
      const paddedMonth = month.toString().padStart(2, '0');
      const paddedDay = day.toString().padStart(2, '0');
      return `${paddedMonth}-${paddedDay} ${hours}:${minutes}`;
    }
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div className="chat-list-page">
      <Navbar title="消息" showBack={false} />

      <div className="chat-list-container">
        {sessionList.length > 0 ? (
          <div className="session-list">
            {sessionList.map((item) => (
              <div
                key={item.id}
                className="session-item"
                onClick={() => openChat(item)}
              >
                <img
                  className="session-avatar"
                  src={item.other_member_avatar || '/avatar.jpg'}
                  alt="avatar"
                />
                <div className="session-info">
                  <div className="session-header">
                    <div className="session-name">{item.other_member_name}</div>
                    <div className="session-time">{formatTime(item.last_time_formatted)}</div>
                  </div>
                  <div className="session-content">{item.last_message}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <span className="empty-icon">💬</span>
            <span className="empty-text">暂无消息</span>
          </div>
        )}
      </div>

      <BottomNav activeTab="notification" />
    </div>
  );
};

export default ChatList;
